/**
 * @author System shock
 * @description Скрипт версии для слабовидящих
 * version: 1.0.3
 *
 */

function theme(){
    const html = document.querySelector('html');

// при клике по кнопке показывается окно с настройками
    const themeBtn = document.querySelector('.svhelp-button');
    if(themeBtn){
        document.querySelector('.svhelp-button').addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.closest('.svhelp').classList.toggle('open');
        });
    }

    // клик "Обычная версия сайта"
    const svhelpDefault = document.querySelector('.svhelp-default');
    if(svhelpDefault){
        svhelpDefault.addEventListener('click', (e) => {
            e.preventDefault();

            html.classList.remove(
                'svhelp-theme-white',
                'svhelp-theme-dark',
                'svhelp-theme-brown',
                'svhelp-theme-blue',
                'svhelp-font-size-small',
                'svhelp-font-size-medium',
                'svhelp-font-size-big',
                'svhelp-font-times',
                'svhelp-font-arial'
            );

            try {
                localStorage.removeItem('svhelp-theme');
                localStorage.removeItem('svhelp-font-size');
                localStorage.removeItem('svhelp-font');
            } catch (err) {
                console.log(err);
            }
            // priorityPlusNav();
        });
    }

// клик "Цветовая схема"
    document.querySelectorAll('.svhelp-item.svhelp-theme .item').forEach(themeItem => {
        themeItem.addEventListener('click', e => {
            e.preventDefault();
            html.classList.remove('svhelp-theme-white', 'svhelp-theme-dark', 'svhelp-theme-brown', 'svhelp-theme-blue');
            html.classList.add(e.target.dataset.svhelpClass);
            try {
                localStorage.setItem('svhelp-theme', e.target.dataset.svhelpClass);
            } catch (err) {
                console.log(err);
            }
        });
    });

// клик "Размер шрифта"
    document.querySelectorAll('.svhelp-item.svhelp-font-size .item').forEach(fontSizeItem => {
        fontSizeItem.addEventListener('click', e => {
            e.preventDefault();
            html.classList.remove('svhelp-font-size-small', 'svhelp-font-size-medium', 'svhelp-font-size-big');
            html.classList.add(e.target.dataset.svhelpClass);
            try {
                localStorage.setItem('svhelp-font-size', e.target.dataset.svhelpClass);
            } catch (err) {
                console.log(err);
            }
            // priorityPlusNav();
        });
    });

// клик "Шрифт"
    document.querySelectorAll('.svhelp-item.svhelp-font .item').forEach(fontItem => {
        fontItem.addEventListener('click', e => {
            e.preventDefault();
            html.classList.remove('svhelp-font-times', 'svhelp-font-arial');
            html.classList.add(e.target.dataset.svhelpClass);
            try {
                localStorage.setItem('svhelp-font', e.target.dataset.svhelpClass);
            } catch (err) {
                console.log(err);
            }
        });
    });

    try {
        if( localStorage.getItem('svhelp-theme') ){
            html.classList.add(localStorage.getItem('svhelp-theme'));
        }
        if( localStorage.getItem('svhelp-font-size') ){
            html.classList.add(localStorage.getItem('svhelp-font-size'));
        }
        if( localStorage.getItem('svhelp-font') ){
            html.classList.add(localStorage.getItem('svhelp-font'));
        }
    } catch (err) {
        console.log(err);
    }
}

export default theme;